var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H12V2H8V4ZM16 21C14.6167 21 13.4373 20.5123 12.462 19.537C11.4867 18.5617 10.9993 17.3827 11 16C11 14.6167 11.4877 13.4373 12.463 12.462C13.4383 11.4867 14.6173 10.9993 16 11C17.3833 11 18.5627 11.4877 19.538 12.463C20.5133 13.4383 21.0007 14.6173 21 16C21 17.3833 20.5123 18.5627 19.537 19.538C18.5617 20.5133 17.3827 21.0007 16 21ZM17.65 18.35L18.35 17.65L16.5 15.8V13H15.5V16.2L17.65 18.35ZM9.675 19H2C1.45 19 0.979002 18.804 0.587002 18.412C0.195002 18.02 -0.000664969 17.5493 1.69779e-06 17V6C1.69779e-06 5.45 0.196002 4.979 0.588002 4.587C0.980002 4.195 1.45067 3.99934 2 4H6V2C6 1.45 6.196 0.979002 6.588 0.587002C6.98 0.195002 7.45067 -0.000664969 8 1.69779e-06H12C12.55 1.69779e-06 13.021 0.196002 13.413 0.588002C13.805 0.980002 14.0007 1.45067 14 2V4H18C18.55 4 19.021 4.196 19.413 4.588C19.805 4.98 20.0007 5.45067 20 6V10.275C19.4167 9.85833 18.7833 9.54167 18.1 9.325C17.4167 9.10834 16.7167 9 16 9C14.05 9 12.3957 9.67934 11.037 11.038C9.67834 12.3967 8.99934 14.0507 9 16C9 16.5333 9.05434 17.05 9.163 17.55C9.27167 18.05 9.44234 18.5333 9.675 19Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.8aff0612c34036793ede9ff5fa873d91.svg";
export { ForwardRef as ReactComponent };